module.exports = __webpack_public_path__ + "img/Fehlertyp1_Dok2.68d7a5a3.jpg";